@if (!!agentInfo) {
  <div class="step mx-auto flex max-w-screen-xl flex-col-reverse xl:flex-row" [class.hidden]="step !== 0">
    <div class="space-y-12 p-4 text-[rgb(0,21,74)]" role="heading">
      <p class="font-sans text-2xl">Hi! I'm {{ agentInfo.firstName }}.</p>
      <p class="font-sans text-2xl">{{ agentInfo.intakeIntro }}</p>
      <p class="font-sans text-2xl">Please take a few moments to complete this intake form.</p>
      <p class="font-sans text-xl text-[rgba(0,21,74,0.7)]">
        P.S. Your submission data using this form is encrypted and HIPAA compliant.
      </p>
    </div>
    <img [src]="agentInfo.pictureUrl" alt="Agent profile picture" class="h-96 w-96 self-center" />
  </div>
} @else {
  <div class="flex w-full justify-around">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
<form
  [formGroup]="intakeForm"
  class="center relative mx-auto mt-28 flex w-full max-w-[720px] flex-col text-[#00154a]"
  (ngSubmit)="submitForm()"
>
  <div class="py-10" [class.hidden]="step !== 1">
    <h2>Let's start with your name and email address</h2>
    <app-intake-form-input
      [formControlInstance]="formControl('1.firstName')"
      label="First name"
      [required]="true"
      ariaLabel="Enter your first name"
      placeholder="Jane"
      autocomplete="given-name"
    ></app-intake-form-input>
    <app-intake-form-input
      [formControlInstance]="formControl('1.lastName')"
      label="Last name"
      [required]="true"
      ariaLabel="Enter your last name"
      placeholder="Smith"
      autocomplete="family-name"
    ></app-intake-form-input>
    <app-intake-form-input
      [formControlInstance]="formControl('1.email')"
      label="Email"
      [required]="true"
      ariaLabel="Enter your email address"
      placeholder="name@example.com"
      autocomplete="email"
      [onKeydownEnter]="nextStep.bind(this)"
    ></app-intake-form-input>
  </div>
  <div class="flex flex-col py-10" [class.hidden]="step !== 2" formGroupName="2">
    <h2>
      What is your Date of Birth?<span class="hidden">This field is required</span><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-input-date
      formControlName="dob"
      [onKeydownEnter]="nextStep.bind(this)"
    ></app-intake-form-input-date>
    <mat-error class="min-h-[1lh]">
      <app-boomer-forms-errors class="text-xl text-red-800" [control]="formControl('2.dob')"></app-boomer-forms-errors>
    </mat-error>
  </div>
  <div class="py-10" [class.hidden]="step !== 3">
    <h2>Address info</h2>
    <app-intake-form-input
      [formControlInstance]="formControl('3.phone')"
      label="Phone Number"
      [required]="true"
      [autocomplete]="'home tel'"
      type="phone"
    ></app-intake-form-input>
    <div class="grid grid-cols-2 gap-x-4">
      <app-intake-form-input
        [formControlInstance]="formControl('3.zip')"
        label="Zip"
        [required]="true"
        [onKeydownEnter]="nextStep.bind(this)"
      ></app-intake-form-input>
      <app-intake-form-county-select
        [form]="this.intakeForm.get('3')"
        [zipCodeControl]="formControl('3.zip')"
        label="County"
        fipsControlName="fips"
        [countyControl]="formControl('3.county')"
        placeholder="Type Zip to choose a county"
      />
    </div>
    <app-intake-form-input
      class="col-span-2"
      [formControlInstance]="formControl('3.state')"
      label="State"
      readOnly="true"
      placeholder="Choose county"
    ></app-intake-form-input>
  </div>
  <div class="py-10" [class.hidden]="step !== 4">
    <h2>
      How familiar are you with Medicare?<span class="hidden">This field is required</span
      ><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-select
      [formControlInstance]="formControl('4.medicareFamiliarity')"
      [onKeydownEnter]="nextStep.bind(this)"
      [options]="[
        'Not well at all, I find it very confusing!',
        'Somewhat familiar, but I have questions about my specific situation and where to begin.',
        'Very familiar. I have a good idea about what I need to do and I am ready to enroll.',
      ]"
    ></app-intake-form-select>
  </div>
  <div class="py-10" [class.hidden]="step !== 5">
    <h2>
      Do you know when you would like your Medicare insurance plan coverage to begin? If not, that's okay, just say "not
      sure".
      <span class="hidden">This field is required</span><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-input
      [formControlInstance]="formControl('5.insuranceBeginDate')"
      [required]="false"
      [onKeydownEnter]="nextStep.bind(this)"
    ></app-intake-form-input>
  </div>
  <div class="py-10" [class.hidden]="step !== 6">
    <h2>
      What type of health insurance do you currently have?<span class="hidden">This field is required</span
      ><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-select
      [formControlInstance]="formControl('6.currentInsuranceType')"
      [onKeydownEnter]="nextStep.bind(this)"
      [options]="currentInsuranceType"
    ></app-intake-form-select>
  </div>
  <div class="py-10" [class.hidden]="step !== 7">
    <h2>
      What is the name of your current health insurance company?
      <span class="hidden">This field is required</span><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-input
      [formControlInstance]="formControl('7.currentCarrier')"
      [required]="false"
      ariaLabel="What is the name of your current health insurance company?"
      [onKeydownEnter]="nextStep.bind(this)"
    ></app-intake-form-input>
  </div>
  <div class="py-10" [class.hidden]="step !== 8">
    <h2>
      Have you enrolled in Medicare already?<span class="hidden">This field is required</span
      ><span aria-hidden="true">*</span>
    </h2>
    <app-intake-form-select
      [formControlInstance]="formControl('8.enrolledInMedicare')"
      [onKeydownEnter]="nextStep.bind(this)"
      [options]="[
        'Yes, I have already enrolled in both Part A & Part B',
        'Yes, but I only have Part A',
        'No, I have not enrolled in Medicare yet',
      ]"
    ></app-intake-form-select>
  </div>
  <div class="py-10" [class.hidden]="step !== 9">
    <h2>Is there additional information about your situation that would be helpful to provide, please do so below.</h2>
    <app-intake-form-input
      type="textarea"
      [formControlInstance]="formControl('9.additionalInfo')"
      [required]="false"
      ariaLabel="Is there additional information about your situation that would be helpful to provide."
    ></app-intake-form-input>
  </div>
  <div class="py-10" [class.hidden]="step !== 10">
    <h2>Who can we thank for referring you?</h2>
    <app-intake-form-input
      [formControlInstance]="formControl('10.referrer')"
      [required]="false"
      ariaLabel="Who can we thank for referring you?"
      [onKeydownEnter]="nextStep.bind(this)"
    ></app-intake-form-input>
  </div>
  <div class="step space-y-12 py-10" [class.hidden]="step !== 11">
    <p class="font-sans text-2xl">Thank you.</p>
    <p class="font-sans text-2xl">Next, please click the button below to complete a Scope of Appointment form.</p>
    <p class="font-sans text-2xl">
      Centers for Medicare & Medicaid (CMS) requires your permission before we can discuss and provide plan information.
    </p>
    <p class="font-sans text-2xl">
      After the Scope of Appointment form is complete, you will be able to register on our portal to add any important
      doctors, medications and your pharmacy choice. We use this information to make plan recommendations based on your
      specific needs and situation.
    </p>
  </div>
  <div class="flex flex-row">
    <button
      type="button"
      (click)="previousStep()"
      class="mr-5 w-fit self-center"
      mat-flat-button
      color="secondary"
      [disabled]="step <= 0"
    >
      Back
    </button>
    <button
      type="button"
      (click)="nextStep()"
      [disabled]="saving"
      class="w-fit self-center"
      mat-flat-button
      color="primary"
      style="background-color: #00154a"
    >
      @if (saving) {
        <mat-progress-spinner mode="indeterminate" diameter="30" />
      } @else {
        @if (step !== 11) {
          Next
        } @else {
          Submit
        }
      }
    </button>
  </div>
</form>
